import { Checkbox } from "@clockwise/design-system";
import { getShortName } from "@clockwise/web-commons/src/util/profile.util";
import Tooltip from "@material-ui/core/Tooltip";
import pluralize from "pluralize";
import React from "react";
import { BulkIconAvatar } from "./BulkIconAvatar";
import { Pill } from "./Pill";
import { InviteSearchPerson } from "./types";

const AttendeeList = ({ attendeeNames }: { attendeeNames: string[] }) => {
  let numberOfTotalCharacters = 0;
  const namesToDisplay = [];
  const namesToNotDisplay = [];
  for (const name of attendeeNames) {
    if (numberOfTotalCharacters + name.length < 20) {
      namesToDisplay.push(name);
      numberOfTotalCharacters += name.length;
    } else {
      namesToNotDisplay.push(name);
    }
  }
  if (!namesToNotDisplay.length) {
    return (
      <div className="md:cw-text-sm cw-text-xs cw-text-muted">{namesToDisplay.join(", ")}</div>
    );
  } else {
    const overflowNames = namesToNotDisplay.map((name, i) => (
      <div key={`${name}_${i}`}>{name}</div>
    ));
    const overflowTooltip = (
      <Tooltip title={<>{overflowNames}</>}>
        <span className="cw-cursor-pointer cw-border-default cw-border-dashed cw-border-b">
          {namesToNotDisplay.length} {pluralize("other", namesToNotDisplay.length)}
        </span>
      </Tooltip>
    );
    return (
      <div className="md:cw-text-sm cw-text-xs cw-text-muted">
        {namesToDisplay.join(", ")} and {overflowTooltip}
      </div>
    );
  }
};

export const BulkInviteResultRow = ({
  title,
  attendees,
  onCheck,
  isChecked,
  eventKey,
  isIndeterminate,
}: {
  title: string;
  attendees: InviteSearchPerson[];
  onCheck: (selectedPersons: InviteSearchPerson[], eventKey: string, checked: boolean) => void;
  isChecked: boolean;
  eventKey: string;
  isIndeterminate: boolean;
}) => {
  const fullNamesList = attendees.map((attendee) => getShortName(attendee.profile));

  const onChange = (checked: boolean) => {
    onCheck(attendees, eventKey, checked);
  };

  const attendeeLength = attendees.length;
  return (
    <div
      className={
        "cw-group cw-p-2 cw-items-center cw-flex cw-w-full hover:cw-bg-default-hover cw-rounded-md"
      }
      onClick={() => onChange(!isChecked)}
    >
      <BulkIconAvatar />
      <div className="cw-flex cw-flex-col cw-flex-1 cw-ml-3 cw-w-full cw-text-ellipsis cw-overflow-hidden cw-whitespace-nowrap">
        <div className="md:cw-heading-base cw-heading-sm cw-text-ellipsis cw-overflow-hidden cw-whitespace-nowrap">{`${attendeeLength} attendees of "${title}"`}</div>
        <div>
          <AttendeeList attendeeNames={fullNamesList} />
        </div>
      </div>
      <Pill>Suggested</Pill>
      <div className="cw-flex cw-items-center cw-gap-3 cw-mr-2">
        <Checkbox checked={isChecked} indeterminate={isIndeterminate} />
      </div>
    </div>
  );
};
